import atob from 'atob';

export const decodedId = (id) => {
  try {
    if (!id) return undefined;
    return atob(id);
  } catch (error) {
    return id;
  }
};
